import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { ConnectorController } from '@web3modal/core';
export function markWalletsAsInstalled(wallets) {
  const {
    connectors
  } = ConnectorController.state;
  const installedConnectors = connectors.filter(c => c.type === 'ANNOUNCED').reduce((acum, val) => {
    var _val$info;
    if (!((_val$info = val.info) !== null && _val$info !== void 0 && _val$info.rdns)) {
      return acum;
    }
    acum[val.info.rdns] = true;
    return acum;
  }, {});
  const walletsWithInstalled = wallets.map(wallet => {
    var _wallet$rdns;
    return _objectSpread(_objectSpread({}, wallet), {}, {
      installed: Boolean(wallet.rdns) && Boolean(installedConnectors[(_wallet$rdns = wallet.rdns) !== null && _wallet$rdns !== void 0 ? _wallet$rdns : ''])
    });
  });
  const sortedWallets = walletsWithInstalled.sort((a, b) => Number(b.installed) - Number(a.installed));
  return sortedWallets;
}
//# sourceMappingURL=markWalletsAsInstalled.js.map